import React from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import SidebarMenu from './SidebarMenu';
import { toggleSidebar } from '../../actions/sidebar';
import {
	colors,
	sidebarWidth,
	sidebarBreakpoint,
	footerHeight,
	topBarHeight,
	preHeaderHeight,
	totalHeaderHeight,
} from '../variables';
import logotype from '../../images/logo_black.svg';

const Container = styled.aside`
	position: fixed;
	top: ${preHeaderHeight + 'px'};
	width: ${sidebarWidth + 'px'};
	height: 200vh;
	background: ${colors.background.secondary};
	border-bottom: 1px solid ${colors.grey.normal};

	@media (max-width: ${sidebarBreakpoint + 'px'}) {
		position: fixed;
		top: ${topBarHeight + 'px'};
		bottom: 0;
		left: 0;
		overflow-y: auto;
		z-index: 300;
		transform: ${props =>
			props.visible
				? 'translate3d(0, 0, 0)'
				: `translate3d(${-sidebarWidth + 'px'}, 0, 0)`};
		transition: transform 0.2s ease-out;
	}

	@media print {
		display: none;
	}
`;

const SidebarContent = styled.div`
	height: calc(100vh - ${totalHeaderHeight + 'px'});
	overflow-y: auto;
	padding-bottom: ${footerHeight + 'px'};

	@media (max-width: ${sidebarBreakpoint + 'px'}) {
		height: calc(100vh - ${topBarHeight + 'px'});
	}
`;

const LogoLink = styled(Link)`
	display: block;
	background: ${colors.background.secondary};
	padding: 15px 52px;
	border-bottom: 1px solid ${colors.grey.normal};

	@media (max-width: ${sidebarBreakpoint + 'px'}) {
		display: none;
	}
`;

const Logo = styled.img`
	margin-left: 0px;
	margin-right: auto;
	display: block;
	height: 41px;
`;

class Sidebar extends React.Component {
	render() {
		const { auth, sidebar, toggleSidebar } = this.props;

		if (!auth.isAuthenticated) return null;

		return (
			<Container visible={sidebar.visible}>
				<LogoLink to="/">
					<Logo src={logotype} alt="Bromma Backyard" />
				</LogoLink>
				<SidebarContent>
					<SidebarMenu auth={auth} toggleSidebar={toggleSidebar} />
				</SidebarContent>
			</Container>
		);
	}
}

const mapStateToProps = state => ({
	auth: state.auth,
	sidebar: state.sidebar,
});

const mapDispatchToProps = dispatch => ({
	toggleSidebar: () => dispatch(toggleSidebar()),
});

export default connect(mapStateToProps, mapDispatchToProps, null, {
	pure: false,
})(Sidebar);



// WEBPACK FOOTER //
// ./src/components/Sidebar/Sidebar.js